import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { VentaService } from '../../services/venta.service';
import { StepperNavigationService } from '../../services/stepper-navigation.service';

@Component({
  selector: 'ticketing-siguiente-button',
  templateUrl: './siguiente-button.component.html',
  styleUrls: ['./siguiente-button.component.scss']
})
export class SiguienteButtonComponent {

  constructor(
    public venta: VentaService,
    public stepper: StepperNavigationService,
    private router: Router
  ) {}

  avanzar() {
    // Obtener la URL actual para determinar el contexto
    const currentUrl = this.stepper.getUrlVentaSlice();
    
    // Para amigos-thyssen, ir directamente sin validaciones de recintos
    if (currentUrl === 'amigos-thyssen') {
      // No establecer continuarVenta en true para que se muestren los selectores
      this.stepper.next();
      return;
    }
    
    // Validación de seguridad: verificar que recintos existe y tiene elementos
    if (this.venta.carritoValue.entradas.some(e => e.entrada.recintos && e.entrada.recintos.length > 0) && this.stepper.pasos[0].url !== 'entradas') {
      const pasos = this.stepper.pasos;
      const findIndexProcedencia = pasos.findIndex(paso => paso.url === 'procedencia');
      const horarioNoExist = pasos.findIndex(paso => paso.url === 'horarios')
      horarioNoExist === -1 && pasos.splice(findIndexProcedencia, 0, this.stepper.horarios);

      this.stepper.pasos = pasos;
      this.stepper.continuarVenta.next(true);
      this.stepper.next();
    }
    else {
      this.stepper.continuarVenta.next(true);
      this.stepper.next();
    }
  }
}
